import { Add, TaskAlt, Warning } from '@mui/icons-material';
import {
  Badge,
  Box,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Menu,
  Typography,
  Switch,
  FormControlLabel,
  Button,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import {
  useGetTaskOwn,
  useGetTaskPriority,
  useGetTaskType,
} from '../hooks/reactQuerys/TaskQueries';
import { CardTask } from './CardTask';
import { useGetUserGroups, useGetUsers } from '../hooks/data';
import { DialogTask } from './DialogTask';
import { useNavigate } from 'react-router-dom';

export const OwnTasks = () => {
  const navigation = useNavigate();

  const { tasks, isLoadingTasks, refetechTasks } = useGetTaskOwn();
  const { taskTypes, isLoadingTaskTypes } = useGetTaskType();
  const { taskPriorities, isLoadingTaskPriorities } = useGetTaskPriority();
  const { users, isLoadingUsers } = useGetUsers();
  const { userGroups, isLoadingUserGroups } = useGetUserGroups();

  const [idTask, setIdTask] = useState<number | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showAll, setShowAll] = useState(false);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    refetechTasks();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  //  Gefilterte Tasks: Standard = nur offene
  const filteredTasks = useMemo(() => {
    if (!tasks) return [];

    if (!showAll) {
      return tasks.filter(task => task.Closed_at === null);
    }

    return tasks;
  }, [tasks, showAll]);

  //  Warning-Badge nur auf gefilterte Tasks
  const warningTask =
    filteredTasks === undefined
      ? []
      : filteredTasks.filter(
          task =>
            new Date(String(task.Deadline_at)).getDate() <= new Date().getDate()
        );

  if (
    isLoadingTasks ||
    isLoadingTaskTypes ||
    isLoadingTaskPriorities ||
    isLoadingUsers ||
    isLoadingUserGroups
  ) {
    return (
      <IconButton color='inherit' title='Meine Aufgaben' disabled>
        <Badge
          badgeContent={<CircularProgress size={10} />}
          color='secondary'
          variant='standard'
        >
          <TaskAlt />
        </Badge>
      </IconButton>
    );
  }

  if (!tasks || !taskTypes || !taskPriorities || !users || !userGroups) {
    return (
      <IconButton color='inherit' title='Meine Aufgaben' disabled>
        <Badge
          badgeContent={<Warning sx={{ fontSize: 20 }} />}
          color='secondary'
          variant='standard'
        >
          <TaskAlt />
        </Badge>
      </IconButton>
    );
  }

  return (
    <Box>
      {idTask && (
        <DialogTask
          idTask={idTask}
          setIdTask={setIdTask}
          refatchTasks={refetechTasks}
          taskPriority={taskPriorities}
          taskTypes={taskTypes}
          userGroups={userGroups}
          users={users}
        />
      )}

      <IconButton
        color='inherit'
        onClick={handleMenuOpen}
        title='Meine Aufgaben'
      >
        <Badge
          badgeContent={warningTask.length}
          color='secondary'
          variant='standard'
        >
          <TaskAlt />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            sx: {
              width: 500,
              maxHeight: '70vh',
              borderRadius: 3,
              p: 1.5,
              overflowY: 'auto',
            },
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2,
            px: 1,
          }}
        >
          <Typography variant='h6' fontWeight={600}>
            Meine Aufgaben
          </Typography>
          <Button onClick={() => navigation('/task')}>Übersicht</Button>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FormControlLabel
              control={
                <Switch
                  size='small'
                  checked={showAll}
                  onChange={e => setShowAll(e.target.checked)}
                />
              }
              label='Alle'
            />

            <Chip size='small' label={`${filteredTasks.length} Tickets`} />

            <IconButton onClick={() => setIdTask(-1)} color='primary'>
              <Add />
            </IconButton>
          </Box>
        </Box>

        <Grid container spacing={1.5}>
          {filteredTasks.map(task => (
            <Grid item xs={12} key={`card-task-${task.idTask}`}>
              <CardTask task={task} setIdTask={setIdTask} />
            </Grid>
          ))}
        </Grid>
      </Menu>
    </Box>
  );
};
